<template lang="pug">
  el-row
    el-col(:span="clientSide ? 22 : 12")
      el-input(
        v-if="showSearch"
        :placeholder="$t('placeholder.search')"
        v-model="search"
        clearable
      )
    el-col.text-right(
      :span="showSearch ? 12 : 24"
    )
      div.d-flex.align-items-center.justify-content-flex-end
        slot
</template>

<script>
export default {
  name: "SearchWithButtons",

  props: {
    value: {
      type: String,
      default: "",
    },

    showSearch: {
      type: Boolean,
    },

    clientSide: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value.replace('%', String.fromCharCode(0xFF05)))
      },
    },
  },
};
</script>
